module.exports = __webpack_public_path__ + "img/success_OLD_f.777c8b30.gif";